import { trpc } from '@/lib/trpc';

const useRegister = () => {
	const { mutate, isPending, error } = trpc.user.register.useMutation();

	return {
		register: mutate,
		registerLoading: isPending,
		registerError: error,
	};
};

export default useRegister;
